module.exports = __webpack_public_path__ + "static/media/icon2.4d744c8f.svg";